import styled, { css } from 'styled-components';
import color from '../../configs/color';

export const RuleWrapper = styled.div`
  border: 1px solid ${color.grey1};
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  p {
    margin-bottom: 4px;
  }
  .containers_users_roleForm_ruleWrapper_sub {
    display: flex;
    padding: 16px;
    column-gap: 34px;
    border-bottom: 1px solid ${color.grey2};
  }

  .containers_users_roleForm_ruleWrapper_sub:last-child {
    border-bottom: unset;
  }

  .containers_users_roleForm_ruleWrapper_grid {
    max-width: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;

export const RuleSwitch = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  padding: 0;
  .ant-switch {
    margin-left: 24px;
  }

  align-items: ${(props) => {
    return props.small ? 'flex-start' : 'center';
  }};

  .component_switch_child.ant-switch-checked {
    background-color: ${color.orange2};
  }

  ${(props) => {
    return (
      props.small &&
      css`
        border-bottom: 1px solid ${color.grey2};
        padding: 16px 0;
        :nth-child(odd) {
          margin-left: 16px;
          padding-right: 16px;
        }
        :nth-child(even) {
          margin-right: 16px;
          padding-left: 16px;
        }

        :last-child:nth-child(odd) {
          /* Last child AND odd */
          border-bottom: unset;
        }

        :nth-last-child(2):nth-child(odd),
        :last-child:nth-child(even) {
          /* Before last child AND odd */
          /* Last child AND even */
          border-bottom: unset;
        }
      `
    );
  }}
`;
